import React from 'react';
import {themableImagePath} from '../utils/imageUtils';
import {formatDuration} from '../utils/dateTimeUtils';

class ExcursionDuration extends React.Component {
    render() {
        return (
            <div className="">
                <img className="w-4 h-4 align-middle mr-2 inline" alt="clock icon" src={themableImagePath('clock.png')} />
                <span className="align-middle text-grey-darker">{formatDuration(this.props.duration)}</span>
            </div>
        )
    }
}

export default ExcursionDuration;